export default function () {
    this.conf.classNames.selected = 'current-menu-item';
    var wpadminbar = document.getElementById('wpadminbar');
    if (wpadminbar) {
        wpadminbar.style.position = 'fixed';
        wpadminbar.classList.add('mm-slideout');
    }
}



//////////////////
// WEBPACK FOOTER
// /Users/emmanuelpiguet/Documents/Web/Local/icmc/app/public/wp-content/themes/icmc/node_modules/mmenu-js/dist/wrappers/wordpress/mmenu.wordpress.js
// module id = 93
// module chunks = 0